import { useQueryClient } from '@tanstack/react-query';
import { Fragment, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { MY_LISTINGS_KEY, MY_PACKAGE_KEY } from '@steelbuy/data-access';
import { useRerenderFromNavbar } from '@steelbuy/util';
import { CreateListingContextProvider } from '../components/create-listing/CreateListingContext';
import { MyListingsContextProvider } from '../components/my-listings/MyListingsContext';
import { MyPackagesContextProvider } from '../components/my-packages/MyPackagesContext';

export const ListingManagementView = () => {
    const rerenderKey = useRerenderFromNavbar();
    const queryClient = useQueryClient();

    useEffect(
        () => () => {
            queryClient.removeQueries({ queryKey: [MY_LISTINGS_KEY] });
            queryClient.removeQueries({ queryKey: [MY_PACKAGE_KEY] });
        },
        []
    );

    return (
        <Fragment key={rerenderKey}>
            <CreateListingContextProvider>
                <MyListingsContextProvider>
                    <MyPackagesContextProvider>
                        <Outlet />
                    </MyPackagesContextProvider>
                </MyListingsContextProvider>
            </CreateListingContextProvider>
        </Fragment>
    );
};
